import { $ as $E, html, type Html, Page } from 'rune-ts';
import klass from './CreatorApplication.module.scss';
import { LayoutView } from '../../components/cells/Layout/LayoutView';
import { BaseLayoutOptions } from '@services/MarppleShop/features/Core/service';
import { footer_links } from '@services/MarppleShop/renderApp/components/cells/Footer/constant.ts';
import { isFixedElementInSection } from '@services/MarppleShop/shared/util/elementPositionHelper.ts';
import { CreatorApplicationHeader } from '@services/MarppleShop/renderApp/pages/CreatorApplication/views/Header';
import { CreatorApplicationSection1 } from '@services/MarppleShop/renderApp/pages/CreatorApplication/views/Section1';
import { CreatorApplicationSection2 } from '@services/MarppleShop/renderApp/pages/CreatorApplication/views/Section2';

export type CreatorApplicationPageData = {
  layout_options: BaseLayoutOptions;
};

class CreatorApplicationBody extends Page<CreatorApplicationPageData> {
  is_mobile = this.data.layout_options.is_mobile;
  headerSection = new CreatorApplicationHeader({ is_mobile: this.is_mobile });
  section1View = new CreatorApplicationSection1({ is_mobile: this.is_mobile });
  section2View = new CreatorApplicationSection2({ is_mobile: this.is_mobile });
  protected override template() {
    return html`
      <div>
        <div class="${klass.page}">
          ${this.headerSection}
          <!--   섹션1     -->
          ${this.section1View}
          <!--   섹션2     -->
          ${this.section2View}
        </div>
      </div>
    `;
  }

  private handleScrollChangeHeaderColor() {
    if (this.headerSection.isRendered()) {
      const $current_section = $E(this.element())
        .findAll(`.${klass.page} > section`)
        .find(($section) => isFixedElementInSection(this.headerSection.element(), $section.element()));
      if ($current_section) {
        if ($current_section.element() == this.section1View.element()) {
          this.headerSection.setThemeColor('white');
        } else {
          this.headerSection.setThemeColor('blue');
        }
      }
    }
  }

  protected override onRender() {
    this.handleScrollChangeHeaderColor();
    document.addEventListener('scroll', () => this.handleScrollChangeHeaderColor(), {
      passive: true,
    });
  }
}

export class CreatorApplicationPage extends Page<CreatorApplicationPageData> {
  protected override template(): Html {
    return html`
      <div class="${klass.page}">
        ${new LayoutView(
          {
            body: new CreatorApplicationBody(this.data),
            footer_data: { ...footer_links, lang: ET.lang, is_mobile: this.data.layout_options.is_mobile },
          },
          {
            ...this.data.layout_options,
            full_width: true,
            has_bottom_tab_bar: false,
            selected_bottom_tab_idx: -1,
          },
        )}
      </div>
    `;
  }
}
